import { render, staticRenderFns } from "./addTagForm.vue?vue&type=template&id=e75e86a4"
import script from "./addTagForm.vue?vue&type=script&lang=js"
export * from "./addTagForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/check/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e75e86a4')) {
      api.createRecord('e75e86a4', component.options)
    } else {
      api.reload('e75e86a4', component.options)
    }
    module.hot.accept("./addTagForm.vue?vue&type=template&id=e75e86a4", function () {
      api.rerender('e75e86a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/addTagForm.vue"
export default component.exports